import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NmInput } from '../input/input';

declare let $: any;

@Component({
	selector: 'nm-radio',
	templateUrl: './radio.html',
	providers: [
		{
	    provide: NG_VALUE_ACCESSOR,
	    useExisting: forwardRef(() => NmRadio),
	    multi: true,
	  }
  ]
})
export class NmRadio extends NmInput {
	@Input() value: any;
	@Input() checked: boolean = false;

	public onInputChange(event: any): void {
		this._value = event.target.value;
		super.onInputChange(event);
	}

	public writeValue(value: any): void {
		super.writeValue(value);

		let elem = $(this.elementRef.nativeElement).find(`input[type="radio"][value="${value}"]`);
		if(value == this._value)
			elem.prop('checked', true);
		else
			elem.prop('checked', false);
	}
}


// WEBPACK FOOTER //
// ./src/widgets/radio/radio.ts